import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import Loading from "../../../../components/loading";
import "./styles/inspecaoFrenteInfo.css";

export function InspecaoFrenteInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllInspFrentTrabalhoById(id, config).then(
                    (res) => {
                        setData(res);
                    }
                );
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    return (
        <div>
            <div className="container-inspe">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Inspeção de frente de trabalho</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main className="datagrid-container-insp">
                                <div className="table-content-insp">
                                    <div key={i}>
                                        <thead>
                                            <tr>
                                                <th>Data</th>
                                                <th>Hora</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td>
                                                {check.dt_inspe ? check.dt_inspe : "Não informado"}
                                            </td>
                                            <td>{check.hr_inspe ? check.hr_inspe : "Não informado"}</td>
                
                                        </tbody>
                                    </div>
                                    <br></br>
                                    <div key={i}>
                                        <thead>
                                            <tr>
                                                <th>Não conformidade</th>
                                                <th>Prazo</th>
                                                <th>Responsavel</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td>{check.nao_conformidade ? check.nao_conformidade : "Não informado"}</td>
                                            <td>{check.prazo ? formatDate(check.prazo) : "Não informado"}</td>
                                            <td>{check.nm_responsavel ? check.nm_responsavel : "Não informado"}</td>
                                        </tbody>
                                    </div>
                                </div>
                            </main>
                    );
                })}
            </div>
        </div>
    );
}
